import { NgModule, LOCALE_ID } from "@angular/core";
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import * as Material from "@angular/material"
import { MAT_DATE_LOCALE } from '@angular/material';
import { MatDatetimepickerModule, MatNativeDatetimeModule } from "@mat-datetimepicker/core";
import { NgxSpinnerModule } from "ngx-spinner";

const materialComponent = [
  CommonModule,
  FormsModule,
  ReactiveFormsModule,
  Material.MatSidenavModule,
  Material.MatToolbarModule,
  Material.MatDividerModule,
  Material.MatButtonModule,
  Material.MatMenuModule,
  Material.MatIconModule,
  Material.MatGridListModule,
  Material.MatListModule,
  Material.MatCardModule,
  Material.MatFormFieldModule,
  Material.MatInputModule,
  Material.MatRadioModule,
  Material.MatSelectModule,
  Material.MatCheckboxModule,
  Material.MatDatepickerModule,
  Material.MatNativeDateModule,
  Material.MatSnackBarModule,
  Material.MatTableModule,
  Material.MatPaginatorModule,
  Material.MatSortModule,
  Material.MatDialogModule,
  Material.MatTabsModule,
  Material.MatTooltipModule,
  Material.MatBadgeModule,
  Material.MatStepperModule,
  Material.MatProgressBarModule,
  Material.MatProgressSpinnerModule,
  Material.MatTreeModule,
  Material.MatExpansionModule,
  
  //for custom mat datepicker
  MatNativeDatetimeModule,
  MatDatetimepickerModule,
  NgxSpinnerModule
];

@NgModule({
  imports: [materialComponent],
  exports: [materialComponent],
  providers: [
    { provide: LOCALE_ID, useValue: 'en-EN' },
    { provide: MAT_DATE_LOCALE, useValue: 'en-EN' },
  ]
})
export class MaterialModule {}
